import { useQuery } from '@tanstack/react-query';

import { listCppPartners } from '~/services/LuxLoyalty';

import { costPerPointQueryKeys } from './costPerPointQueryKeys';

/** Lists all partners (id, name, partnerType, ...) for the CPP dropdowns/filters. */
export function useCppPartners() {
  return useQuery({
    queryKey: costPerPointQueryKeys.partners(),
    queryFn: async ({ signal }) => {
      return await listCppPartners({ signal });
    },
    retry: false,
  });
}
